<template>
  <span
    v-if="numberOfLines"
    :ellipsizeMode="ellipsizeMode"
    :numberOfLines="parseInt(numberOfLines)"
    :style="[basicStyle, customStyle]"
    @click="onClick"
  >
    <slot />
  </span>
  <span
    v-else
    :style="[basicStyle, customStyle]"
    @click="onClick"
  >
    <slot />
  </span>
</template>

<script>
import { calcNum } from '../StyleSheet';

const SIZE_MAP = {
  xxxs: 9,
  xxs: 10,
  xs: 12,
  s: 14,
  sl: 15,
  m: 16,
  ml: 17,
  l: 18,
  xl: 20,
  xsl: 21,
  xxl: 24,
  xxxsl: 25,
  xxxl: 30,
  xxxxl: 40,
  xxxxxl: 45,
};

const FONT_WEIGHT_MAP = {
  Thin: 100,
  Hairline: 100,
  ExtraLight: 200,
  UltraLight: 200,
  Light: 300,
  Normal: 400,
  Regular: 400,
  Medium: 500,
  SemiBold: 600,
  DemiBold: 600,
  Bold: 700,
  ExtraBold: 800,
  UltraBold: 800,
  Black: 900,
  Heavy: 900,
  ExtraBlack: 950,
  UltraBlack: 950,
};

export default {
  name: 'HyText',
  props: {
    size: { // 字体大小
      type: String,
      default: 'm',
      isRequired: false,
      validator: val => ['xxxs', 'xxs', 'xs', 's', 'sl', 'm', 'ml', 'l', 'xl', 'xsl', 'xxl', 'xxxsl', 'xxxl', 'xxxxl', 'xxxxxl'].includes(val),
    },
    color: {
      type: String,
      default: '#303133',
      isRequired: false,
    },
    fontWeight: {
      type: [Number, String],
      default: '400',
    },
    align: {
      type: String,
      default: 'auto',
    },
    lineHeight: {
      type: [Number, String],
      default: 0,
    },
    height: {
      type: [Number, String],
      default: 0,
    },
    numberOfLines: {
      type: [Number, String],
      default: 0,
    },
    ellipsizeMode: {
      type: String,
      default: 'tail',
    },
    customStyle: {
      type: [Object, Array],
      default: () => {
      },
    },
  },
  computed: {
    basicStyle: {
      get() {
        const style = {
          fontSize: calcNum(SIZE_MAP[this.size]),
          fontWeight: FONT_WEIGHT_MAP[this.fontWeight] || (Number(this.fontWeight) ? this.fontWeight : 400),
          color: this.color,
          textAlign: this.align,
        };
        this.lineHeight && (style.lineHeight = calcNum(this.lineHeight));
        this.height && (style.height = calcNum(this.height));
        if (!this.customStyle?.wordBreak) {
          style.wordBreak = 'break-word';
        }
        return style;
      },
    },
  },
  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
  },
};
</script>
